import * as types from './mutation_types'
import ApiService from '@/utils/ApiService'
import Vue from 'vue'
export const create = async ({ commit }, values) => {
  commit(types.EXCMCARUSERDATA_CREATE_SET_ERROR, '')
  commit(types.EXCMCARUSERDATA_CREATE_TOGGLE_LOADING)
  const response = await new ApiService('e_x_c_m_car_user_datas').post(values)
  let responseData = await response.json()
  if (response.status === 201) commit(types.EXCMCARUSERDATA_CREATE_SET_CREATED, responseData)
  else {
    let text = ''
    for (let i in responseData) {
      text += responseData[i] + '\n'
    }
    Vue.prototype.$Swal({
      type: 'warning',
      title: text,
      timer: 2500
    })
  }
  commit(types.EXCMCARUSERDATA_CREATE_TOGGLE_LOADING)
}

export const reset = ({ commit }) => {
  commit(types.EXCMCARUSERDATA_CREATE_RESET)
}
